import React from 'react';
import AppConfig from 'Config/AppConfig';
import AuthFooter from '../../../Components/AuthFooter/AuthFooter';
import styles from './Auth2Error.module.less';
import PiplLogo from '../../../../../static/img/pipl_logo.svg';

export const Auth2Error = () => {
  const email = window.__INITIAL_STATE && window.__INITIAL_STATE.auth2_email;
  const sefUrl = window.__INITIAL_STATE?.sef_url || '/';

  return (
    <>
      <div className={styles.centerForm}>
        <a href={sefUrl}>
          <img className={styles.logo} src={PiplLogo} alt="Pipl" width="120" height="75" />
        </a>

        <div className={styles.wrapper}>
          <div className={`${styles.textBlock} ${styles.text} ${styles.boldText}`}>
            Oops! Did you use the right account?
          </div>
          <div className={styles.textBlock}>
            <span className={styles.text}>It looks like the email address you entered </span>
            {email && <span className={`${styles.text} ${styles.boldText}`}>({email}) </span>}
            <span className={styles.text}>is the wrong one.</span>
          </div>
          <div className={styles.textBlock}>
            <span className={styles.text}>
              If you&#39;re like most of us, you have more than one email address. Can you check to be sure you&#39;re
              using the right one?
            </span>
          </div>
          <div className={styles.textBlock}>
            <span className={styles.text}>
              If you&#39;re certain you&#39;re using the correct email address, please contact your administrator.
            </span>
          </div>
        </div>

        <a className={styles.btn} href={`/${AppConfig.ACCOUNTS_PREFIX}login/`} id="submit-id-login">
          Try a different account
        </a>
      </div>
      <AuthFooter />
    </>
  );
};

export default Auth2Error;
